export default {
      id: "icon-safety-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite.svg#icon-safety",
      toString: function () {
        return this.url;
      }
    }